import {
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Grid,
  Group,
  LoadingOverlay,
  rem,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconEye, IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryMaster, repositoryPos } from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { cobalt_blue, gray, sky_blue } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { UserMasterCreateModel } from "../../model/UserMasterModel";
import { _validateUserMasterModelValidator } from "../../validate/UserCreateModelValidator";
import { getValueById } from "../../_base/helper/FunctionHelper";

const UserCreate = function ({ onLoad }: { onLoad: () => Promise<void> }) {
  const entity: UserMasterCreateModel = {
    id: 0,
    userName: "",
    password: "",
    empid: 0,
  };
  const form = useForm<UserMasterCreateModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: _validateUserMasterModelValidator,
  });

  const [dataEmployeeSelect, setDataDmEmployeeSelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const [showPass, SetShowPass] = useState<boolean>(false);
  let typePass = showPass ? "text" : "password";
  let colorEye = showPass ? cobalt_blue.base : gray.base;
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const icon = (
    <IconEye
      onClick={() => {
        SetShowPass(!showPass);
      }}
      style={{ width: rem(20), height: rem(20), color: colorEye }}
    />
  );

  const changeUserName = (str: string) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/đ/g, "d")
      .replace(/Đ/g, "D")
      .toLowerCase()
      .trim();
  };

  const apiCreate = async (data: UserMasterCreateModel) => {
    console.log(data);
    open();
    data.id = 0;
    let urlCreate = `/api/v1/auth/create-pass`;
    const callapi = await repositoryMaster.post(urlCreate, data);
    if (callapi)
      if (callapi?.success) {
        await onLoad();
        NotificationExtension.Success("Thêm mới thành công !");
        modals.closeAll();
      } else if (callapi != null)
        NotificationExtension.Fails("Thêm mới thất bại !");
    close();
  };

  const dataDmEmployeeSelect = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-all"
    );

    if (res && res.success) {
      const result = res.data;
      setDataEmployee(result);
      setDataDmEmployeeSelect(
        result
          .filter((item: any) => item.fullname && item.id)
          .map((item: any) => ({
            value: String(item.id),
            label: `${item.code} - ${item.fullname}`,
          }))
      );
    }
  };
  const callApiGetData = async () => {
    open();
    let urlCreate = `/api/v1/auth/create`;
    const callapi = await repositoryMaster.get<
      MessageResponse<UserMasterCreateModel>
    >(urlCreate);
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
        await dataDmEmployeeSelect();
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };

  useEffect(() => {
    callApiGetData();
  }, []);

  return (
    <>
      <Box
        component="form"
        onSubmit={form.onSubmit(async (e: UserMasterCreateModel) => {
          await apiCreate(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Box className="flex-none" component="form" mx="auto">
          <Grid>
            <Grid.Col span={{ base: 12, xs: 6 }}>
              <Select
                id="managerId"
                key={form.key("managerId")}
                label="Nhân viên: "
                placeholder="Nhập..."
                nothingFoundMessage="Không có dữ liệu"
                data={dataEmployeeSelect}
                value={form.getValues().empid?.toString()}
                searchable
                clearable
                withAsterisk
                {...form.getInputProps("managerId")}
                onChange={(e) => {
                  form.setValues((prev) => ({
                    ...prev,
                    empid: Number.parseInt(e ?? "0"),
                    fullName: dataEmployee.filter(
                      (item) => String(item.id) === e
                    )[0]?.fullname,
                    userName:
                      changeUserName(
                        String(
                          getValueById(e ? e : "", dataEmployeeSelect, "label")
                            ?.trim()
                            ?.split(" ")
                            ?.pop()
                        )
                      ) +
                      "-" +
                      getValueById(e ? e : "", dataEmployeeSelect, "label")
                        ?.split("-")[0]
                        ?.trim(),
                    phone: dataEmployee.filter(
                      (item) => String(item.id) === e
                    )[0]?.phoneNumber,
                  }));
                }}
              />
            </Grid.Col>

            <Grid.Col span={{ base: 12, xs: 6 }}>
              <TextInput
                label="Tên đầy đủ: "
                placeholder="Nhập..."
                withAsterisk
                {...form.getInputProps("fullName")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, xs: 6 }}>
              <TextInput
                label="Tên đăng nhập: "
                placeholder="Nhập..."
                disabled={!localStorage.getItem("adminEditEmp")}
                withAsterisk
                {...form.getInputProps("userName")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, xs: 6 }}>
              {" "}
              <TextInput
                key={form.key("phone")}
                label="Số điện thoại: "
                placeholder="Nhập..."
                {...form.getInputProps("phone")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, xs: 6 }}>
              <TextInput
                type={typePass}
                leftSection={icon}
                label="Mật khẩu: "
                placeholder="Nhập..."
                withAsterisk
                {...form.getInputProps("password")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, xs: 6 }}>
              <TextInput
                type={typePass}
                leftSection={icon}
                label="Nhập lại mật khẩu: "
                placeholder="Nhập..."
                withAsterisk
                {...form.getInputProps("confirmPassword")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, xs: 6 }}>
              {" "}
              <TextInput
                label="Trung tâm: "
                placeholder="Nhập..."
                {...form.getInputProps("center")}
              />
            </Grid.Col>
          </Grid>

          <Grid></Grid>
          <Checkbox
            mt={"xs"}
            label="Trạng thái"
            defaultValue={form.getValues().inActive ?? false}
            defaultChecked={form.getValues().inActive ?? false}
            {...form.getInputProps("inActive")}
          />
        </Box>
        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default UserCreate;
